import { createContext } from 'react';
export const MasqueradeContext = createContext();